<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('pilotage_payments')"
                        :isNewButton="checkPermission('pilotagepayment_store')"
                        :isColumns="true"
                        @new-button-click="createFormShow"
                        :is-import-button="checkPermission('pilotagepayment_excelimport')"
                        @import-button-click="importData"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('pilotage_payments')"
                              :isNewButton="checkPermission('pilotagepayment_store')"
                              :isColumns="true"
                              @new-button-click="createFormShow"
                              :is-import-button="checkPermission('pilotagepayment_excelimport')"
                              @import-button-click="importData"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :exportExcel="checkPermission('pilotagepayment_excelexport')"
                              @exportExcel="exportExcel"
            >
                <b-row>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('customer')">
                            <customers-auto-complete v-model="datatable.queryParams.filter.customer_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('subject')">
                            <b-form-input v-model="datatable.queryParams.filter.subject"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('amount')">
                            <b-form-input v-model="datatable.queryParams.filter.amount" type="number"/>
                        </b-form-group>
                    </b-col>
<!--                    <b-col sm="4" md="4">-->
<!--                        <b-form-group :label="$t('currency')">-->
<!--                            <b-form-select v-model="datatable.queryParams.filter.amount" :options="[-->
<!--                                            { value: 'TRY', text: 'TRY' },-->
<!--                                            { value: 'USD', text: 'USD' },-->
<!--                                            { value: 'EUR', text: 'EUR' }-->
<!--                                        ]">-->
<!--                            </b-form-select>-->
<!--                        </b-form-group>-->
<!--                    </b-col>-->
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('due_date')">
                            <select-date v-model="datatable.queryParams.filter.due_date"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('amount_paid')">
                            <b-form-input v-model="datatable.queryParams.filter.paid_amount" type="number"/>
                        </b-form-group>
                    </b-col>


                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('pilotagepayment_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('pilotagepayment_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('pilotagepayment_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
            <CommonModal ref="addPaymentFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('pilotagepayment_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('add_payment').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <add-payment-form :formId="formId"
                                 @addPaymentFormSuccess="addPaymentFormSuccess"
                                 v-if="formProcess=='addPayment'"/>
                </template>
            </CommonModal>
            <CommonModal ref="importFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('import').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <import-excel @successProcess="importFormSuccess" v-if="formProcess == 'import'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import CustomersAutoComplete from "@/components/interactive-fields/CustomersAutoComplete.vue";

    //Page
    import CreateForm from './CreateForm'
    import ShowForm from './ShowForm'
    import UpdateForm from './UpdateForm'
    import AddPaymentForm from './AddPaymentForm.vue';
    import ImportExcel from '@/modules/pilotagePayments/pages/ImportExcel.vue';

    //Service
    import PilotagePaymentsService from '@/services/PilotagePaymentsService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            ImportExcel,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            CustomersAutoComplete,

            CreateForm,
            ShowForm,
            UpdateForm,
            AddPaymentForm,
        },
        metaInfo() {
            return {
                title: this.$t('pilotage_payments')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'pilotagepayment_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'pilotagepayment_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('add_payment'),
                                    class: 'ri-add-line align-middle top-minus-1 mr-3 text-muted',
                                    permission: 'pilotagepaymentdetail_show',
                                    callback: (row) => {
                                        this.addPaymentFormShow(row.id)
                                    }
                                },
                                {
                                    text: this.$t('download'),
                                    permission:'pilotagepayment_download',
                                    class: 'ri-download-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.download(row)

                                    },
                                    show: function (row) {
                                        if(row.has_file){
                                            return true;
                                        }
                                        return false;
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'pilotagepayment_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('student_number'),
                            field: 'number',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('name_surname'),
                            field: 'name',
                            formatFn: (value, row) => {
                                return row.name + ' ' + row.surname;
                            },
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('subject'),
                            field: 'subject',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('amount'),
                            field: 'amount',
                            hidden: false,
                            formatFn: this.formatNumber
                        },
                        {
                            label: this.toUpperCase('currency'),
                            field: 'currency',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('due_date'),
                            field: 'due_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('amount_paid'),
                            field: 'paid_amount',
                            hidden: false,
                            formatFn: this.formatNumber
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return PilotagePaymentsService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData() {
                this.formProcess = 'update';
                PilotagePaymentsService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.deleteModal(() => {
                    PilotagePaymentsService.del(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    });
                });
            },
            exportExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                return PilotagePaymentsService.exportExcel(config)
                    .then((response) => {
                        this._downloadFile(response, 'pilotage_payment.xlsx')
                    })
                    .catch(e => {
                    });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            addPaymentFormShow(id) {
                this.formId = id
                this.formProcess = 'addPayment'
                this.$refs.addPaymentFormModal.$refs.commonModal.show()
            },
            async addPaymentFormSuccess() {
                this.$refs.addPaymentFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            download(row) {
                PilotagePaymentsService.download(row.id).then(response=>{
                    this._downloadFile(response, row.file.file_name)
                })
            },
            importFormSuccess(){
                this.formProcess = null
                this.$refs.importFormModal.$refs.commonModal.hide()
            },
            importData(){
                this.formProcess = 'import'
                this.$refs.importFormModal.$refs.commonModal.show()
            }
        }
    }
</script>
